import React from 'react';
import './LoadingView.css';

interface LoadingViewProps {
  message?: string;
  /** Use for full-page loading (centered in viewport) */
  fullPage?: boolean;
}

/**
 * Retorno visual de carregamento — sem opção de cancelar.
 * Otimizado: DOM mínimo, animação CSS (GPU), sem JS no loop.
 */
const LoadingView: React.FC<LoadingViewProps> = ({
  message = 'Carregando...',
  fullPage = true,
}) => (
  <div className={`loading-view ${fullPage ? 'loading-view--full' : ''}`} role="status" aria-live="polite" aria-label={message}>
    <div className="loading-view__spinner" aria-hidden="true" />
    <span className="loading-view__text">{message}</span>
  </div>
);

export default React.memo(LoadingView);
